import script from "./TrainingSessionDetailsModalV2.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingSessionDetailsModalV2.vue?vue&type=script&setup=true&lang=js"

import "./TrainingSessionDetailsModalV2.vue?vue&type=style&index=0&id=15c37b8d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c37b8d"]])

export default __exports__